import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { FiGrid, FiUsers, FiShoppingBag, FiDollarSign, FiSliders, FiTag, FiSettings, FiLogOut, FiMenu, FiX, FiArrowLeft } from 'react-icons/fi';
import './AdminLayout.css';

export default function AdminLayout() {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const navItems = [
    { to: '/admin', icon: <FiGrid />, label: 'Dashboard', end: true },
    { to: '/admin/users', icon: <FiUsers />, label: 'Users' },
    { to: '/admin/stores', icon: <FiShoppingBag />, label: 'Stores' },
    { to: '/admin/payments', icon: <FiDollarSign />, label: 'Payments' },
    { to: '/admin/plan-settings', icon: <FiSliders />, label: 'Plan Settings' },
    { to: '/admin/promo-codes', icon: <FiTag />, label: 'Promo Codes' },
    { to: '/admin/settings', icon: <FiSettings />, label: 'Settings' },
  ];

  return (
    <div className="admin-dashboard">
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="admin-sidebar-header">
          <div className="admin-logo">
            <img className="cartz-mark admin-cartz-mark" src="/favicon.svg" alt="" />
            <div>
              <div className="admin-logo-text">Cartz</div>
              <div className="admin-logo-sub">Super Admin</div>
            </div>
          </div>
          <button className="admin-sidebar-close" onClick={() => setSidebarOpen(false)}>
            <FiX />
          </button>
        </div>

        <nav className="admin-sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              {item.icon}
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <NavLink to="/dashboard" className="admin-nav-link" onClick={() => setSidebarOpen(false)}>
            <FiArrowLeft />
            <span>Back to Dashboard</span>
          </NavLink>
          <button className="admin-nav-link admin-logout" onClick={handleLogout}>
            <FiLogOut />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <header className="admin-header">
          <button className="admin-mobile-btn" onClick={() => setSidebarOpen(true)}>
            <FiMenu />
          </button>
          <div className="admin-header-right">
            <span>Welcome, <strong>{user?.first_name}</strong></span>
          </div>
        </header>
        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
